import { Select } from "antd";
import { useCurrencySelectOptions } from "components/UI/Selects/CurrencySelectSearchable/useCurrencySelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

export const CurrencySelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useCurrencySelectOptions();

    if (hookResult.loading && !hookResult.options.length) {
        return <Select {...props} loading disabled size={props.size ?? "middle"} />;
    }

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.currency"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
